/** @type {import("../../../../shared/ui/data-table/model/data-table-contract").UnifiedTableRecord[]} */
export const documents = [
  {
    patientId: "11",
    module: "documents",
    pageTitle: "Documents",

    subnav: [],

    sections: [
      {
        id: "documents-section",
        title: "Documents",
        tables: [
          {
            id: "documents-main",
            columns: [
              { key: "docName", header: "Document Name", sortable: true },
              { key: "docType", header: "Document Type", sortable: true },
              { key: "docDate", header: "Scan Date", sortable: true },
              { key: "docFileType", header: "File Type", sortable: true },
              {
                key: "viewUrl",
                header: "",
                rendererId: "docUrl",
                align: "right",
                width: 120,
                frozen: "right",
              },
            ],
            rows: [
              {
                docName: "Blood Test Results",
                docType: "Lab Report",
                docDate: "12/07/2017",
                docFileType: "PDF",
                viewUrl:
                  "https://drive.google.com/file/d/1iG2d9rNGmhVIDa-HuNH3KN3awnEIcAAy/view?usp=sharing",
              },
              {
                docName: "X-Ray Chest",
                docType: "Imaging (X-Ray)",
                docDate: "12/07/2017",
                docFileType: "JPEG",
                viewUrl:
                  "https://drive.google.com/file/d/1HOTRNVhyVTxqduJ5Lo5buUsdA6miOaAE/view?usp=drive_link",
              },
              {
                docName: "Abdomen Scan",
                docType: "Imaging (CT)",
                docDate: "12/07/2017",
                docFileType: "JPEG",
                viewUrl:
                  "https://drive.google.com/file/d/1HOTRNVhyVTxqduJ5Lo5buUsdA6miOaAE/view?usp=drive_link",
              },
              {
                docName: "QUEST Copy Svc - Bruce L.Scheiner Law Office",
                docType: "Release of Information",
                docDate: "06/26/2017",
                docFileType: "TIFF",
                viewUrl:
                  "https://drive.google.com/file/d/1x35OBeK3G3qnQe24PVXeRUZJrEHwZ3oK/view?usp=drive_link",
              },
              {
                docName: "Bruce L. Schreiner~Records Request",
                docType: "Release of Information",
                docDate: "02/24/2017",
                docFileType: "TIFF",
                viewUrl:
                  "https://drive.google.com/file/d/1XhX4_1KvCeDKjoF4lLy2FCk5Xm2XgbVE/view?usp=drive_link",
              },
              {
                docName: "Financial Policy",
                docType: "Financial Policy",
                docDate: "02/10/2017",
                docFileType: "TXT",
                viewUrl:
                  "https://drive.google.com/file/d/1HOTRNVhyVTxqduJ5Lo5buUsdA6miOaAE/view?usp=drive_link",
              },
              {
                docName: "HIPAA",
                docType: "HIPAA",
                docDate: "02/10/2017",
                docFileType: "TXT",
                viewUrl:
                  "https://drive.google.com/file/d/1iG2d9rNGmhVIDa-HuNH3KN3awnEIcAAy/view?usp=sharing",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: ["docName", "docType", "docDate", "docFileType"],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=12LaHzrtjq2NZ8uXuFJVkKph30ooPoNs8",
                pdf: "https://drive.google.com/uc?export=download&id=1l4MaCHDMzKO-3HK9-cVdZnsepLRn976W",
                xls: "https://docs.google.com/spreadsheets/d/1N_RoqcP5L4X7_13lEjePcI7mVZG3-P2C/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },
    ],
  },
];
